import IdeaSelect from '@components/IdeaSelect'
import Modal from '@components/Modal'
import { GetIdeaResponse } from '@orbit/api-types'
import { backgroundOrange } from '@/theme/colors'
import React, { useState } from 'react'
import { ButtonComponent, ButtonGroupComponent } from '../AddEventModal/FormComponents'
import { IdeaSelectWrapper } from './ImportIdeaModal.styles'
import { TestIds } from '@/testIds'

interface ImportIdeaModalProps {
	isOpen: boolean
	onClose: () => void
	onNext: (idea: GetIdeaResponse) => void
	ideas: GetIdeaResponse[]
}

const ImportIdeaModal: React.FC<ImportIdeaModalProps> = ({ isOpen, onClose, onNext, ideas }) => {
	const [selectedIdeaId, setSelectedIdeaId] = useState<number | null>(null)

	const handleNext = () => {
		if (selectedIdeaId) {
			const selectedIdea = ideas.find(b => b.id === selectedIdeaId)
			if (selectedIdea) {
				onNext(selectedIdea)
				setSelectedIdeaId(null)
			}
		}
	}

	const handleCancel = () => {
		setSelectedIdeaId(null)
		onClose()
	}

	const handleIdeaChange = (ideaId: number) => {
		setSelectedIdeaId(ideaId)
	}

	return (
		<Modal
			isOpen={isOpen}
			onClose={handleCancel}
			title="Import from Idea"
			closeOnBackdropClick={false}
			backgroundColor={backgroundOrange}
		>
			<IdeaSelectWrapper>
				<IdeaSelect
					label="Select Idea"
					htmlFor="idea-select"
					ideas={ideas}
					value={selectedIdeaId}
					onChange={handleIdeaChange}
				/>
			</IdeaSelectWrapper>
			<ButtonGroupComponent>
				<ButtonComponent type="button" variant="secondary" onClick={handleCancel}>
					Cancel
				</ButtonComponent>
				<ButtonComponent
					type="button"
					variant="primary"
					onClick={handleNext}
					disabled={!selectedIdeaId}
					data-testid={TestIds.itinerary.importIdeaNextButton}
				>
					Next
				</ButtonComponent>
			</ButtonGroupComponent>
		</Modal>
	)
}

export default ImportIdeaModal

